module.exports = __webpack_public_path__ + "static/logo-88679a5f1bf527f77c413a6627207f91.jpg";